/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { platform } from 'network-utils';

const accountSettingsApis = platform.learningPanel.AccountSettingsAPIs;
export const getAccountData = 'account-data';
export const getUserSettings = 'user-settings';

export const useGetAccountData = (userUuid: string) => {
    return useQuery([getAccountData, userUuid], () => accountSettingsApis.getAccountData(), {
        staleTime: Infinity,
        retry: 1
    });
};

export const useGetUserSettings = (userUuid?: string) => {
    return useQuery([getUserSettings, userUuid], () => accountSettingsApis.getUserSettings(), { staleTime: Infinity });
};
